import isBcom from '../utils/isBcom';

const MAX_SWATCH_SIZE = isBcom ? 82 : 64;
const MAX_COLORS_DISPLAYED = 5;
const mcomColorSwatchUrl = 'https://slimages.macysassets.com/is/image/MCY/swatches/';
const bcomColorSwatchUrl = 'https://images.bloomingdalesassets.com/is/image/BLM/swatches/';

// constructing sprite url
export default function buildColorSwatchSprite(colors) {
  let swatchSize = colors.length;
  let swatchUrlTemplate;
  const isBcomBrand = isBcom && Boolean(colors[0]?.imagery?.urlTemplate?.includes('BLM'));
  const brandAbbreviation = isBcomBrand ? 'BLM' : 'MCY';
  const brandColorSwatchUrl = isBcomBrand ? bcomColorSwatchUrl : mcomColorSwatchUrl;

  if (colors[0]?.urlTemplate) {
    swatchUrlTemplate = `${colors[0].urlTemplate.swatch}?&$b=${brandAbbreviation}/swatches/&layer=0&size=`;
  } else {
    swatchUrlTemplate = `${brandColorSwatchUrl}?&$b=${brandAbbreviation}/swatches/&layer=0&size=`;
  }

  if (swatchSize > MAX_COLORS_DISPLAYED) {
    swatchSize = MAX_COLORS_DISPLAYED;
  }
  const countStr = `&cropN=0,0,${swatchSize},1`;
  let swatchUrl = `${swatchUrlTemplate}${parseInt(
    swatchSize * MAX_SWATCH_SIZE,
    10,
  )},${MAX_SWATCH_SIZE}${countStr}`;
  let swatchParams = '';
  for (let i = 0; i < swatchSize; i++) {
    const val = colors[i];
    if (val?.swatchImage?.filePath) {
      const pre = `&src=is{$b$${val.swatchImage.filePath}}&anchor=0,0&layer=${
        i + 1
      }&size=`;
      const post = `&posN=${((1 / swatchSize) * (i + 1)).toFixed(3)},0`;
      swatchParams += `${pre}${MAX_SWATCH_SIZE},${MAX_SWATCH_SIZE}${post}`;
    }
    colors[i].showJumboSwatch = colors[i].imagery?.primaryImage?.showJumboSwatch || false;
    if (swatchSize - 1 === 0) {
      colors[i].offset = 0;
    } else {
      colors[i].offset = ((i / (swatchSize - 1)) * 100).toFixed(3);
    }
  }

  const opts = '&op_sharpen=1&fmt=jpeg&qlt=90,0&hei=';
  swatchUrl = `${swatchUrl + swatchParams}${opts}${MAX_SWATCH_SIZE}`;

  return { swatchUrl, colors };
}
